import { render, staticRenderFns } from "./PlacementSection.vue?vue&type=template&id=123d5689&scoped=true"
import script from "./PlacementSection.vue?vue&type=script&lang=js"
export * from "./PlacementSection.vue?vue&type=script&lang=js"
import style0 from "./PlacementSection.vue?vue&type=style&index=0&id=123d5689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d5689",
  null
  
)

export default component.exports